import { render, staticRenderFns } from "./NeedSomething.vue?vue&type=template&id=63c6d8d8&scoped=true&"
import script from "./NeedSomething.vue?vue&type=script&lang=js&"
export * from "./NeedSomething.vue?vue&type=script&lang=js&"
import style0 from "./NeedSomething.vue?vue&type=style&index=0&id=63c6d8d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c6d8d8",
  null
  
)

export default component.exports